// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const IndonesianBankCodes: MarkdocTagRegistration = {
  tag: 'indonesian-bank-codes-table',
  component: 'IndonesianBankCodesTable',
  attributes: {
    entries: {
      type: Array,
      default: [],
      required: true,
    },
  },
};
